export const DIALOGUE_URL = "/apps/task_manage_szjc/#/"; // AI对话

// export const DIALOGUE_URL = "http://localhost:9298/apps/task_manage_szjc/#/"; // AI对话
